import { render } from "./NavbarProjectPrice.vue?vue&type=template&id=11821191&scoped=true"
import script from "./NavbarProjectPrice.vue?vue&type=script&lang=js"
export * from "./NavbarProjectPrice.vue?vue&type=script&lang=js"

import "./NavbarProjectPrice.vue?vue&type=style&index=0&id=11821191&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11821191"]])

export default __exports__